import React, { Component } from "react";
import PropTypes from "prop-types";
import cloneDeep from "lodash/cloneDeep";
import values from "lodash/values";
import moment from "moment";
import LaneCard from "./LaneCard";
import { rangeLabelsMap } from "../../utils";

class Range extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lanesOverdue: null
    };

    this.checkOverdue = this.checkOverdue.bind(this);
  }

  componentDidMount() {
    // @see: https://github.com/airbnb/javascript/issues/684#issuecomment-172383685
    this.timer = setInterval(this.checkOverdue, 1000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  checkOverdue() {
    // iterate all lanes and identify overdue one
    const { range } = this.props;

    const lanesOverdue = {};
    const limit = moment.duration(20, "minutes");

    Object.keys(range).forEach(rangeName => {
      if (!(rangeName in lanesOverdue)) {
        lanesOverdue[rangeName] = {};
      }

      values(range[rangeName]).forEach(lane => {
        // check lane's overdue
        let overdue = false;
        let duration = null;
        if (lane && lane.assignment) {
          duration = moment.duration(moment().diff(lane.assignment.updated));

          if (duration > limit) {
            overdue = true;
          } else {
            overdue = false;
          }
        } else {
          overdue = false;
        }

        lanesOverdue[rangeName][lane.number] = {
          overdue,
          overdueTime: duration
            ? `${duration.hours()}h:${duration.minutes()}m`
            : ""
        };
      });
    });

    this.setState(() => ({
      lanesOverdue
    }));
  }

  render() {
    const { className, range, isLoading } = this.props;
    const { lanesOverdue } = this.state;
    
    return isLoading
      ? <div />
      : <div className={className}>
          {Object.keys(range).map(rangeName => {
            const rangeLabel = rangeLabelsMap[rangeName] || rangeName;
            const lanes = values(cloneDeep(range[rangeName]));
            lanes.sort((a, b) => a.number - b.number);
            return (
              <div key={`range-${rangeName}`}>
                <div className="md-cell md-cell--12 staff-page--headline">
                  { rangeLabel.toUpperCase()}
                </div>
                <div
                  className="md-cell md-cell--12"
                  style={{ backgroundColor: "grey" }}
                >
                  <div className="md-grid">
                    {lanes.map(lane => {
                      const laneOverdue = lanesOverdue &&
                        lanesOverdue[rangeName]
                        ? lanesOverdue[rangeName][lane.number]
                        : { overdue: false, overdueTime: "" };
                      return (
                        <LaneCard
                          range={rangeName}
                          className="md-cell md-cell--2"
                          key={lane.number}
                          lane={{
                            ...lane,
                            ...laneOverdue
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>;
  }
}

Range.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  // Firebase data
  range: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
  className: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default Range;



// WEBPACK FOOTER //
// ./src/staff/components/Range/Range.jsx